import { Suspense } from 'react';
import { Await, Navigate, useLoaderData, useOutlet } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';

import { LOGIN_PATH } from '~configs';
import { AuthProvider } from '~providers';

export const AuthTemplate = () => {
  const outlet = useOutlet();

  const { userPromise } = useLoaderData() as {
    userPromise: Promise<unknown>;
  };

  return (
    <Suspense fallback={<LinearProgress />}>
      <Await
        resolve={userPromise}
        errorElement={<Navigate to={LOGIN_PATH} replace />}
        children={() => <AuthProvider>{outlet}</AuthProvider>}
      />
    </Suspense>
  );
};
